import { Component, OnInit, Input } from '@angular/core';
import { animations } from '@shared/components/actions-button/animations';
import { ActionButton } from '@app/shared/models/action-button';

@Component({
  selector: 'app-actions-button',
  templateUrl: './actions-button.component.html',
  styleUrls: ['./actions-button.component.scss'],
  animations: animations
})

export class ActionsButtonComponent implements OnInit {
  @Input() actionsButtons: ActionButton[];
  @Input() method: Function;


  buttons: ActionButton[] = [];
  fabTogglerState = 'inactive';

  constructor() { }

  ngOnInit() {
  }

  showItems(): void {
    this.fabTogglerState = 'active';
    this.buttons = this.actionsButtons;
  }

  hideItems(): void {
    this.fabTogglerState = 'inactive';
    this.buttons = [];
  }

  onToggleFab(): void {
    this.buttons && this.buttons.length ? this.hideItems() : this.showItems();
  }

  executeAction(btn: ActionButton): void {
    btn.func();
  }
}
